import React from "react";
import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import { format } from "date-fns";
import { SxProps } from "@mui/material";

interface ObservationPrintCardProps {
  observation: any;
  sx?: SxProps;
}

const ObservationPrintCard: React.FC<ObservationPrintCardProps> = ({ observation, sx }) => {
  return (
    <Card variant="outlined" sx={{ display: 'flex', maxWidth: 900, margin: 'auto', minHeight: 200 }}>
      {observation.photoUrl && (
        <CardMedia
          component="img"
          sx={{
            width: 200,
            height: 200,
            objectFit: 'cover',
            flexShrink: 0,
            borderRight: '1px solid #eee',
          }}
          image={observation.photoUrl}
          alt="Observation photo"
        />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {observation.category} <span style={{ fontWeight: 'normal', fontSize: 14 }}>({format(new Date(observation.observationDate), 'yyyy-MMM-dd')})</span>
          </Typography>
          <Typography color="text.secondary"><b>Familiarity</b>: {observation.familiarity}</Typography>
          <Typography color="text.secondary"><b>Concentration</b>: {observation.concentration}</Typography>
          <Typography color="text.secondary"><b>Notes</b>: {observation.observationNotes}</Typography>
        </CardContent>
      </Box>
    </Card>
  );
};

export default ObservationPrintCard;
